const env = import.meta.env;

export default {
  apiUrl: env.VITE_API_URL_NEW,
  apiVersion: env.VITE_API_VERSION,
  appName: env.VITE_APP_NAME,
  awsUserPoolId: env.VITE_AWS_COGNITO_USER_POOL_ID,
  awsCognitoClientId: env.VITE_AWS_COGNITO_CLIENT_ID,
  awsUserPoolId2: env.VITE_AWS_COGNITO_USER_POOL_ID_2,
  awsCognitoClientId2: env.VITE_AWS_COGNITO_CLIENT_ID_2,
  awsUserPoolIdUsername: env.VITE_AWS_COGNITO_USER_POOL_ID_USERNAME,
  awsCognitoClientIdUsername: env.VITE_AWS_COGNITO_CLIENT_ID_USERNAME,
  awsCognitoDomainUsername: env.VITE_AWS_COGNITO_DOMAIN_USERNAME,
  awsCognitoDomain: env.VITE_AWS_COGNITO_DOMAIN,
  countryStateCityAPIKey: env.VITE_COUNTRY_STATE_CITY_API_KEY,
  googleLoginEnabled: env.VITE_GOOGLE_LOGIN_ENABLED,
  mavatarEnvironments: env.VITE_MAVATAR_ENVIRONMENTS || 'dev', // "dev" | "staging" | "prod"
  useTutorStreaming: (env.VITE_USE_TUTOR_STREAMING || 'true') === 'true',
  starsPerQuiz: 3,
  topicsPerSection: 3,
  topicsPerSectionDesktop: 5,
  isMGWebsite: (env.VITE_MG_DOMAIN || '').toLowerCase() === location.host.toLowerCase(),
  mgAwsUserPoolId: env.VITE_MG_AWS_COGNITO_USER_POOL_ID,
  mgAwsCognitoClientId: env.VITE_MG_AWS_COGNITO_CLIENT_ID,
  mgAwsCognitoDomain: env.VITE_MG_AWS_COGNITO_DOMAIN,
  googleAnalyticsId: env.VITE_GOOGLE_ANALYTICS_ID || '',
  s3BaseUrl: env.VITE_S3_BASE_URL,
  teachersPageSize: Number(env.VITE_TEACHERS_PAGE_SIZE) || 50,
  groupsPageSize: Number(env.VITE_GROUPS_PAGE_SIZE) || 50,
  studentsPageSize: Number(env.VITE_STUDENTS_PAGE_SIZE) || 50,
  /** Max students per class (UI: list column `4/50`, View Class meta, full-class checks). */
  maxStudentsPerClass: 50,
  classNameMaxLength: 40,
  schoolNameMaxLength: 70,
  notificationsQlUrl: env.VITE_NOTIFICATIONS_QL_URL,
};
